<template>
    <el-popover placement="right-start" @show="popoverShow" :trigger="trigger" v-model="visible" width="500">
      <el-table :data="list"
                size="mini"
                border
                style="width: 100%">
        <el-table-column label="分区信息">
          <template v-slot="scope">
            <span style="color:#FF4D01;">
              <template>
                {{ searchText !== '全部' && scope.row.zipCodes.includes(searchText) ? searchText : '' }}
              </template>
              <template v-if="searchText !== '全部' && scope.row.zipCodes.includes(searchText) && filterCode !== searchText && filterCode">,</template>
              <template v-if="filterCode && filterCode !== searchText">{{ filterCode }}</template>
            </span>
            <template v-if="removeSearchText(scope.row.zipCodes).length > 0 && removeSearchText(scope.row.zipCodes).length < scope.row.zipCodes.length">,</template>
            <span>
              {{ removeSearchText(scope.row.zipCodes).join(',') }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <slot slot="reference"></slot>
    </el-popover>
</template>

<script>
export default {
  name: "index",
  props: {
    list: {
      type: Array,
      default: []
    },
    searchText: {
      type: String,
      default: ''
    },
    filterCode: {
      type: String,
      default: ''
    },
    trigger: {
      type: String,
      default: 'hover'
    },
    // trigger为manual生效
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    popoverShow() {
      this.$emit('show')
    },
    removeSearchText(list) {
      let data
      if (this.searchText === '全部' && (!list.includes(this.searchText) && !this.filterCode)) {
        data = list
      } else {
        data = list.filter(code => code !== this.searchText && code !== this.filterCode)
      }
      return data
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/regionDetail/index.vue